<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <fragment v-if="show">
      <PolicyForm
        :form="form"
        @submit="submit"
        @modality="changeToModality"
        @cancel="cancelForm"
        v-if="currentView == 'form'"
        name-button="SALVAR"
        is-edit
        :options-policy="currentPolicyEdit.opcoes"
      />
      <ListModalityAndSubModality v-else :form="form" @return="changeToForm" />
    </fragment>
    <ModalGenericCriticism
      v-model="modal"
      @close="previousPage"
      title="APÓLICE EDITADA"
      text="Apólice editada com sucesso."
    />
    <ModalCancelInsurance
      @close="closeModal"
      v-model="modalCancel"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </Main>
</template>
<script>
import PolicyForm from "../components/PolicyForm";
import ListModalityAndSubModality from "../components/ListModalityAndSubModality";
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import ModalGenericCriticism from "@/modules/quotation/components/ModalGenericCriticism";
import ModalCancelInsurance from "../../insurance_company/components/ModalCancelInsurance";
import _ from "lodash";
import {
  formatIsoDateToDDMMYYYY,
  formatDateToDDMMYYYY
} from "@/utils/formats.js";
import PolicyMixin from "@/mixins/PolicyMixin";
import CompanyMixin from "@/mixins/CompanyMixin";
import FormMixin from "@/mixins/FormMixin";
const DEFAULT_OFFICE = {
  id: "00000000-0000-0000-0000-000000000000",
  nome_fantasia: "NENHUM"
};
const DEFAULT_REGION_COURT = {
  id: "00000000-0000-0000-0000-000000000000",
  nome_fantasia: "NÃO SE APLICA"
};
export default {
  beforeRouteLeave(to, from, next) {
    this.modalCancel = true;
    this.nextRoute = to;
    if (this.cancel || this.formIsPristineCommon(this.form, this.cloneForm))
      next();
  },
  data: () => ({
    form: {
      apolice: [],
      modalidade: {},
      submodalidade: {},
      boletos: [],
      tomador: {
        razao_social: null,
        grupo: {
          nome: null
        }
      },
      cosseguros: [],
      segurado: {
        endereco: {}
      },
      processo: {
        segmento: {
          id: "justica_trabalho"
        },
        tipo_processo: {
          nome: null
        },
        tribunal: {
          nome: null
        },
        unidade: {
          nome: null
        }
      },
      parcelas: [],
      prorrogar_vigencia: false,
      escritorio: null,
      situacao: {}
    },
    show: false,
    currentView: "form",
    breadcrumb: [
      {
        text: "Editar Apólice",
        to: "policy"
      }
    ],
    modal: false,
    formatIsoDateToDDMMYYYY,
    formatDateToDDMMYYYY,
    modalCancel: false,
    nextRoute: null,
    cancel: false,
    cloneForm: {}
  }),
  mixins: [CompanyMixin, LoadingRequest, PolicyMixin, FormMixin],
  created() {
    this.fetchItems();
  },
  components: {
    PolicyForm,
    ListModalityAndSubModality,
    ModalGenericCriticism,
    ModalCancelInsurance
  },
  computed: {
    ...mapState("policy", ["currentPolicyEdit"])
  },
  methods: {
    ...mapActions("policy", [
      "requestListInsuranceCompany",
      "requestListSituation",
      "requestListEmission",
      "requestEditPolicy",
      "requestCurrentPolicyEdit"
    ]),
    ...mapActions("insuranceCompany", ["requestPaymentMethods"]),
    ...mapActions("quotation", ["requestInsuranceCompanyQuotation"]),
    ...mapActions(["showAlertNotification"]),
    fetchItems() {
      this.withLoading(
        Promise.all([
          this.requestListSituation(),
          this.requestListEmission(),
          this.requestInsuranceCompanyQuotation(),
          this.requestListInsuranceCompany(),
          this.requestPaymentMethods(),
          this.requestCurrentPolicyEdit(this.$route.params.id)
        ])
      );
    },
    fetchCurrentPolicy() {
      this.withLoading(this.requestCurrentPolicy(this.$route.params.id));
    },
    async submit(form) {
      this.withLoading(
        this.requestEditPolicy(await this.getPayloadEditPolicy(form)).then(
          () => {
            this.modal = true;
            this.cancel = true;
          }
        )
      );
    },
    async getPayloadEditPolicy(form) {
      const payload = await this.getPayloadPolicy(
        form,
        this.currentPolicyEdit.opcoes
      );
      return {
        payload: payload,
        id: this.$route.params.id
      };
    },
    previousPage() {
      this.modal = false;
      if (this.currentView == "form") {
        this.$router.push({
          name: "details policy",
          params: { id: this.$route.params.id }
        });
      } else {
        this.changeToForm();
      }
    },
    changeToModality() {
      this.currentView = "modality";
      this.breadcrumb = [
        {
          text: "Alterar Modalidade",
          to: "policy"
        }
      ];
    },
    changeToForm() {
      this.currentView = "form";
      this.breadcrumb = [
        {
          text: "Editar Apólice",
          to: "policy"
        }
      ];
    },
    updateForm() {
      this.form = this.mergePropertiesReplacing(
        this.form,
        _.cloneDeep(this.currentPolicyEdit)
      );
      if (this.currentPolicyEdit.arquivo)
        this.form.apolice.push(this.currentPolicyEdit.arquivo);
      if (this.form.data_prorrogacao)
        this.form.data_prorrogacao = this.formatDateToDDMMYYYY(
          this.form.data_prorrogacao
        );
      if (this.form.cancelada_em)
        this.form.cancelada_em = this.formatDateToDDMMYYYY(
          this.form.cancelada_em
        );
      if (this.form.data_vencimento_parcela1)
        this.form.data_vencimento = this.formatDateToDDMMYYYY(
          this.form.data_vencimento_parcela1
        );
      if (this.form.emitida_em)
        this.form.emitida_em = this.formatDateToDDMMYYYY(this.form.emitida_em);
      if (this.form.fim_vigencia)
        this.form.fim_vigencia = this.formatDateToDDMMYYYY(
          this.form.fim_vigencia
        );
      if (this.form.inicio_vigencia)
        this.form.inicio_vigencia = this.formatDateToDDMMYYYY(
          this.form.inicio_vigencia
        );
      this.form.parcelas.forEach((item, key) => {
        if (item.vencimento)
          item.vencimento = this.formatDateToDDMMYYYY(item.vencimento);
        item.numero = key + 1;
      });
      this.form.numero_parcela = this.form.parcelas.length;
      this.form.prorrogar_vigencia = Boolean(this.form.data_prorrogacao);
      this.form.razao_social = this.form.tomador;
      this.form.percentual_comissao =
        this.form.percentual_comissao == 0
          ? "0"
          : this.form.percentual_comissao;
      this.form.nome_fantasia = this.form.tomador.nome_fantasia;
      if (this.form.processo.unidade == null) {
        this.form.processo.unidade = _.cloneDeep(DEFAULT_REGION_COURT);
      }
      if (this.form.escritorio == null) {
        this.form.escritorio = _.cloneDeep(DEFAULT_OFFICE);
      }
      if (!this.form.origem_cadastro) {
        this.form.origem_cadastro = { nome: "CADASTRO LSP" };
      }
      this.cloneForm = _.cloneDeep(this.form);
      this.show = true;
    },
    cancelForm() {
      this.$router.push({
        name: "details policy",
        params: { id: this.$route.params.id }
      });
    },
    closeModal(value) {
      this.cancel = value;
      this.modalCancel = false;
      if (value) {
        this.$router.push({ name: this.nextRoute.name });
      }
    }
  },
  watch: {
    currentPolicyEdit() {
      this.updateForm();
    }
  }
};
</script>
